<template>
  <div class="app-main-content">
    <div class="tabs-container">
      <el-tabs v-model="activeTabName" type="card" style="width:100%" @tab-click="handleTabClick">
        <el-tab-pane :label="$t('CargoMsg.Cargo_VehicleRequestForm')" name="useCarApplicationFormTab">
          <use-car-application-form-tab
            ref="useCarApplicationFormTab"
            :lob="lob"
            :source="SystemConstants.LOAD_POOL_SOURCE_HOME_PAGE.code"
          />
        </el-tab-pane>
        <el-tab-pane :label="$t('CargoMsg.Cargo_VehicleOrder')" name="carFormTab">
          <car-form-tab
            ref="carFormTab"
            :lob="lob"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import UseCarApplicationFormTab from '@/components/Cargo/CarForm/useCarApplicationFormTab'
import CarFormTab from '@/components/Cargo/CarForm/carFormTab'

export default {
  name: 'CarForm',
  components: { UseCarApplicationFormTab, CarFormTab },
  props: {
    lob: { type: String, default: '' }
  },
  data() {
    return {
      SystemConstants,
      activeTabName: 'useCarApplicationFormTab'
    }
  },
  created() {
    // this.handleTabClick()
  },
  methods: {
    handleTabClick() {
      if (this.activeTabName === 'useCarApplicationFormTab') {
        this.$nextTick(() => {
          this.$refs.useCarApplicationFormTab.init()
        })
      } else {
        this.$nextTick(() => {
          this.$refs.carFormTab.init()
        })
      }
    }
  }
}
</script>

<style scoped>

</style>
